export default __webpack_public_path__ + "static/media/MarcaImg.439b6c5a.png";